import Sonda from '@gc-npm/utils.monitoring.sonda';
import getUUID from '@gc-npm/utils.monitoring.get-uuid';
import Request from '@gc-npm/utils.fetch';
import { calculateHeaderParams } from '@gc-npm/node.build-process.build-environments';
import { FAMILY_API } from '@gc-npm/utils.enums.environment';

const PATH = '/api/v1/config-controller/purchase';
const EVENT_NAME = {
  CLIENT: 'SSR_CONFIG.PURCHASE_CLIENT',
  OPEN: 'SSR_CONFIG.PURCHASE',
};
const METHOD = 'GET';

export const purchase = ({
  context,
  build = false,
  onSuccess,
  idFront = 'TC',
  selectedIds,
  clientInfo,
  sessionZone,
  price,
  urlParams,
  purchaseInProgress,
  processId,
}) => {
  const idRequest = getUUID(idFront);
  const sonda = new Sonda({
    eventName: context.userType ? EVENT_NAME.CLIENT : EVENT_NAME.OPEN,
    context,
    uniqueId: idRequest,
    origin: 'ADABYRON-API',
  });

  try {
    const { 'ssr-backend': connectionData, name } = context.environment;
    let { endpoint: host } = connectionData;
    if (name === 'local') {
      // mientras desarrollamos
      host = 'http://127.0.0.1:8080';
    }
    const headers2Use = calculateHeaderParams(build, FAMILY_API.SSR_BACKEND, context);
    // const headers2Use = calculateHeaderParams(build, FAMILY_API.SSR_TVCONFIG, context);
    let params = '';
    if (selectedIds) {
      const selectedIdsParam = encodeURIComponent(JSON.stringify(selectedIds));
      params += `&selectedIds=${selectedIdsParam}`
    }
    if (clientInfo) {
      const clientInfoParam = encodeURIComponent(JSON.stringify(clientInfo));
      params += `&clientInfo=${clientInfoParam}`;
    }
    if (sessionZone) {
      params += `&sessionZone=${sessionZone}`;
    }
    if (price) {
      params += `&price=${price}`;
    }
    if (urlParams?.debugServer) {
      params += `&urlParamsDebug=${urlParams.debugServer}`;
    }
    if (purchaseInProgress) {
      const purchaseInProgressParam = encodeURIComponent(JSON.stringify(purchaseInProgress));
      params += `&purchaseInProgress=${purchaseInProgressParam}`;
    }
    if (urlParams?.directBuyProcess) {
      params += `&directBuyProcess=${Boolean(urlParams.directBuyProcess)}`;
    }
    if(processId) {
      params += `&processId=${processId}`;
    }
    if (urlParams?.compact) {
      params += `&compactProcess=${urlParams.compact[0]}`;
    }
    if(context?.clientIDs) {
      const clientIDInfo = {
        partyIdHash: context?.userIdPartyHash,
        IDs: {
          ga: context?.clientIDs?.ga,
          session_id: context?.clientIDs?.sessionId
        }
      }
      const clientIDsParam = encodeURIComponent(JSON.stringify(clientIDInfo));
      params += `&clientIDs=${clientIDsParam}`
    }
    const URL_API = `${host}${PATH}?${idRequest}${params}`;
    const request = new Request({
      method: METHOD,
      endpoint: URL_API,
      data: '',
      build,
      headers: {
        ...headers2Use,
      },
      onError: () => {
        return null;
      },
      sonda,
      onSuccess: (response) => {
        return onSuccess({ response });
      },
    });
    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};
export default purchase;
